<script>
import TablefieldText from './FieldText.vue'
import TablefieldBoolean from './FieldBoolean.vue'
import TablefieldPercent from './FieldPercent.vue'
import TablefieldComposite from './FieldComposite.vue'
import TablefieldDate from './FieldDate.vue'
import TablefieldDateRange from './FieldDateRange.vue'
import TablefieldDecimal from "./FieldDecimal";
import TablefieldCurrency from "./FieldCurrency";
import TablefieldComponent from "./FieldComponent";
import TableFieldCombinedMultirow from "./FieldCombinedMultirow";
import TablefieldTexts from "./FieldTexts";
import TablefieldFactsheet from "./FieldFactsheet";
import TablefieldFallback from "./FieldFallback";

const TableFieldMixin = {
  components: {
    TablefieldText,
    TablefieldBoolean,
    TablefieldPercent,
    TablefieldComposite,
    TablefieldDate,
    TablefieldDateRange,
    TablefieldDecimal,
    TablefieldCurrency,
    TablefieldComponent,
    TableFieldCombinedMultirow,
    TablefieldTexts,
    TablefieldFactsheet,
    TablefieldFallback,
  },
}

export default TableFieldMixin
</script>



// WEBPACK FOOTER //
// FieldMixin.vue?40986b04